/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEqual from 'lodash/isEqual';

import {GetBgShowcase} from '../../actions/showcase/actions-showcase';

import BgSliderItem from '../../components/BgSlide/bg-slider-item';
import BgSliderControls from '../../components/BgSlide/bg-slider-controls';

class BgSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
      interval: null
    }
  }

  componentWillMount() {

    this.props.GetBgShowcase(this.props.showcaseLabel);
  }

  componentWillReceiveProps(newProps) {

    if (_size(newProps.background.slider) && !_isEqual(newProps.background.slider, this.props.background.slider)) this._initSlider(newProps);

    if (_get(Config, 'stop_animation_on_playback', true) && newProps.isPlayback && !this.props.isPlayback) {

      if (this.state.interval) clearInterval(this.state.interval);
    }

    if (_get(Config, 'stop_animation_on_playback', true) && !newProps.isPlayback && this.props.isPlayback) {

      this._initSlider(newProps, true);
    }
  }

  componentWillUnmount() {

    if (this.state.interval) clearInterval(this.state.interval);
  }

  _initSlider(newProps, isContinueFromLast) {
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }

    if (newProps.background.slider_delay) this.setState({
      interval: setInterval(()=> {
        this.setState({currentSlide: (_size(newProps.background.slider) > this.state.currentSlide + 1) ? this.state.currentSlide + 1 : 0});
      }, newProps.background.slider_delay),
      currentSlide: isContinueFromLast ? this.state.currentSlide : 0
    });
  }

  _isActive(index) {

    return this.state.currentSlide === index;
  };

  _onNext = () => {

    this.setState({currentSlide: (_size(this.props.background.slider) > this.state.currentSlide + 1) ? this.state.currentSlide + 1 : 0});

    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
    this.setState({
      interval: setInterval(()=> {
        this.setState({currentSlide: (_size(this.props.background.slider) > this.state.currentSlide + 1) ? this.state.currentSlide + 1 : 0});
      }, this.props.background.slider_delay)
    });
  };

  _onPrev = () => {
    this.setState({currentSlide: (this.state.currentSlide < 1 ) ? _size(this.props.background.slider) - 1 : this.state.currentSlide - 1});

    if (this.state.interval) {
      clearInterval(this.state.interval);
    }
    this.setState({
      interval: setInterval(()=> {
        this.setState({currentSlide: (_size(this.props.background.slider) > this.state.currentSlide + 1) ? this.state.currentSlide + 1 : 0});
      }, this.props.background.slider_delay)
    });
  };

  _renderSlides() {

    return this.props.background.slider.map((slide, index) => {
      return <BgSliderItem key={'slide_' + index} is-active={this._isActive(index)} item={slide} onAssetSelect={this.props.onAssetSelect}/>;
    });
  }

  render() {
    if (!_size(this.props.background.slider)) {

      return null;
    }

    return (<div>
        <div id="app-background">
          <div id="app-background" className="bg_slider">
            <div className="bg_slides slider">
              {this._renderSlides()}
              { !!_size(this.props.background.slider) && <BgSliderControls onPrev={this._onPrev} onNext={this._onNext} /> }
            </div>
          </div>
        </div>
      </div>);
  }
}

BgSlider.propTypes = {
  showcaseLabel: PropTypes.string,
  background: PropTypes.object.isRequired,
  onAssetSelect: PropTypes.func
};

const mapStateToProps = ({showcase: {background}, common: {player}}) => ({
  background,
  isPlayback: !!player.stream_url
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({GetBgShowcase}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BgSlider);



// WEBPACK FOOTER //
// ./src/containers/BgSlider/bg-slider.js